import { FieldError } from 'react-hook-form';

// yup reports a failed `.min()` rule under this type.
const MIN_LENGTH_ERROR_TYPE = 'min';

export const isMinLengthError = (error?: FieldError) =>
  error?.type === MIN_LENGTH_ERROR_TYPE;
